<template>
  <div class="micr-viewer">
    <div
      class="micr-viewer__frame"
      :class="{ 'micr-viewer__frame--dragging': isDragging }"
      @dblclick="reset">
      <img
        :src="src"
        class="micr-viewer__img"
        :style="imageStyle"
        ref="image"
        @mousedown="startDrag"
        alt="Check image" />
    </div>

    <div class="micr-viewer__controls">
      <button type="button" class="btn-small outlined-btn waves-effect" @click="rotateClockwise">
        <i class="fas fa-redo"></i> Rotate
      </button>
      <button type="button" class="btn-small outlined-btn waves-effect" @click="zoomIn" :disabled="zoom >= MAX_ZOOM">
        <i class="fas fa-search-plus"></i> Zoom in
      </button>
      <button type="button" class="btn-small outlined-btn waves-effect" @click="zoomOut" :disabled="zoom <= MIN_ZOOM">
        <i class="fas fa-search-minus"></i> Zoom out
      </button>
      <button type="button" class="btn-small outlined-btn waves-effect" @click="reset">
        <i class="fas fa-compress-arrows-alt"></i> Fit
      </button>
      <span class="micr-viewer__hint">Drag to move, double-click to fit</span>
    </div>
  </div>
</template>

<script>
const MIN_ZOOM = 0.4
const MAX_ZOOM = 8
const ZOOM_STEP = 1.35

export default {
  props: {
    src: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      MIN_ZOOM,
      MAX_ZOOM,
      rotationDegrees: 0,
      zoom: 1,
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      imagePositionX: 0,
      imagePositionY: 0
    }
  },
  computed: {
    // translate first, so a drag delta maps 1:1 to screen pixels no matter how
    // the image is rotated or scaled.
    imageStyle() {
      return {
        transform: `translate(${this.imagePositionX}px, ${this.imagePositionY}px) ` +
          `rotate(${this.rotationDegrees}deg) scale(${this.zoom})`
      }
    }
  },
  beforeDestroy() {
    this.stopDrag()
  },
  methods: {
    rotateClockwise() {
      this.rotationDegrees += 90
    },
    zoomIn() {
      this.zoom = Math.min(MAX_ZOOM, this.zoom * ZOOM_STEP)
    },
    zoomOut() {
      this.zoom = Math.max(MIN_ZOOM, this.zoom / ZOOM_STEP)
    },
    // Back to the whole check on screen, upright. The way out of any pan or
    // zoom that lost the MICR line off the edge of the frame.
    reset() {
      this.rotationDegrees = 0
      this.zoom = 1
      this.imagePositionX = 0
      this.imagePositionY = 0
    },
    startDrag(event) {
      event.preventDefault()
      this.isDragging = true
      this.dragStartX = event.clientX
      this.dragStartY = event.clientY
      document.addEventListener('mousemove', this.dragImage)
      document.addEventListener('mouseup', this.stopDrag)
    },
    dragImage(event) {
      if(!this.isDragging) { return }

      this.imagePositionX += event.clientX - this.dragStartX
      this.imagePositionY += event.clientY - this.dragStartY
      this.dragStartX = event.clientX
      this.dragStartY = event.clientY
    },
    stopDrag() {
      this.isDragging = false
      document.removeEventListener('mousemove', this.dragImage)
      document.removeEventListener('mouseup', this.stopDrag)
    }
  }
}
</script>
